<form class="row-cols-sm-auto" [ngClass]="{ 'no-margin': noMargin }">
  <div class="col-12 input-wrapper input-group" tabindex="0">
    <app-time-input [time]="from || ''" [disabled]="disabled" (timeChange)="onFromChange($event)" />
    <p class="dash" [ngClass]="{ empty: !from }">-</p>
    <app-time-input [time]="to || ''" [disabled]="disabled" (timeChange)="onToChange($event)" />
  </div>
</form>
